import { useEffect, useState } from "react";
import {
  GenericTable,
  Spinner,
  Pagination,
  SearchableDropdown,
} from "../../../Components/Common";
import { formatDateDDMMYYYY } from "../../../Utils";
import { getSTLStatusColor, STL_COLUMNS, STL_LABELS } from "./constant";
import { useSTL } from "../Hooks/useSTL";
import { useWarehouse } from "../../Inventory/Hooks/useWarehouse";

const StockLedgerList = () => {
  const {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchAllSTLs,
  } = useSTL();

  const { fetchWarehouses } = useWarehouse();
  const [stlRows, setStlRows] = useState([]);

  const fetchSTLs = async () => {
    const response = await fetchAllSTLs();
    console.log("response: ", response);
    setStlRows(Array.isArray(response) ? response : []);
  };

  useEffect(() => {
    fetchSTLs();
  }, [filters, page, rowsPerPage]);

  // Render Field Values for Table
  const renderFields = (key, rowData) => {
    switch (key) {
      case "error_message":
        return (
          <span
            className="font-normal truncate-[90%]"
            title={rowData.error_message}
          >
            {rowData.error_message}
          </span>
        );

      case "date":
        const date = rowData.created.split("T")[0];
        return formatDateDDMMYYYY(date);
      case "status":
        return (
          <span
            className={`px-1.5 py-1 rounded-md text-xs font-medium ${getSTLStatusColor(
              rowData.status
            )}`}
          >
            {rowData.status}
          </span>
        );
      default:
        return rowData[key];
    }
  };
  // Mobile Card View
  const renderMobileCards = () => (
    <div className="space-y-3 px-2">
      {stlRows.length > 0 ? (
        stlRows.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm p-3 flex flex-col gap-2"
          >
            {/* Header */}
            <div className="flex justify-between items-start gap-1">
              <div className="font-semibold text-gray-800 text-sm truncate">
                {item.warehouse_name}
              </div>
              <div className="font-semibold text-gray-800 text-sm truncate">
                {item.product_name}
              </div>
            </div>

            {/* Row 1: Entity & Transaction */}
            <div className="flex justify-between items-start gap-2 text-gray-700 text-xs">
              <div className="flex flex-col">
                <span className="font-medium truncate">
                  Entity: {item.entity_type}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-medium truncate">
                  Transaction: {item.transaction_type}
                </span>
              </div>
            </div>

            {/* Row 2: Date & Raised By */}
            <div className="flex justify-between items-center text-gray-700 text-xs">
              <div>
                <span className="font-medium">Raised On:</span>{" "}
                {formatDateDDMMYYYY(item.date.split("T")[0])}
              </div>
              <div>
                <span className="font-medium">By: </span>{" "}
                {item.initiated_by_name}
              </div>
            </div>

            {/* Footer */}
            <div>
              <span
                className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${getSTLStatusColor(
                  item.status
                )}`}
              >
                {item.status}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div className="w-full h-[250px] flex justify-center items-center text-gray-300 flex-col">
          <span>No Material Requests</span>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-4 mt-2 md:mt-0 px-4 py-4">
        <h2 className="text-xl font-semibold flex items-center gap-2 mt-4">
          Stock Transaction Ledger
        </h2>
      </div>

      <div className="bg-white w-full rounded-2xl shadow-md border px-4 py-3 mb-2">
        <div className="flex flex-wrap gap-2 items-center">
          <SearchableDropdown
            fetchFunction={fetchWarehouses}
            onSelect={(warehouse) =>
              setFilters({ ...filters, warehouse: warehouse })
            }
            valueKey="id"
            labelKey="name"
            placeholder="Select Warehouse"
            width="64"
            includeAllOption={true}
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-[60vh]">
          <Spinner />
        </div>
      ) : (
        <div>
          <div className="hidden md:block h-[54vh] overflow-y-auto">
            <GenericTable
              tableColumns={STL_COLUMNS}
              tableRows={stlRows}
              columnLabels={STL_LABELS}
              renderField={renderFields}
            />
          </div>

          {/* Mobile View */}
          <div className="block md:hidden h-[62vh] overflow-y-auto">
            {renderMobileCards()}
          </div>

          <Pagination
            page={page}
            rowsPerPage={rowsPerPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default StockLedgerList;
